import {initializeSwiper} from './swiper.js'

const fetchWithHeader = async (url, retries = 5, delay = 1000) => {
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const response = await fetch(url)
      const data = await response.json()
      const headers = {}

      // Store headers in an object
      response.headers.forEach((value, name) => {
        headers[name] = value
      })

      return {data, headers}
    } catch (error) {
      console.error(`Error fetching data (attempt ${attempt + 1}):`, error)
      if (attempt < retries - 1) {
        await new Promise((resolve) => setTimeout(resolve, delay))
      } else {
        return {data: null, headers: {}}
      }
    }
  }
}

// Function to get data and headers
const getData = async (url) => {
  const {data, headers} = await fetchWithHeader(url)
  return {data, headers}
}

const getJapanTime = () => {
  // 現在のUTC時間を取得
  let japanTime = new Date()
  // console.log('japanTime', japanTime)

  // // 日本標準時 (JST) のオフセットはUTC+9時間
  // const japanTimeOffset = 9 * 60 // 9時間を分に変換

  // // UTCの分から日本時間の分を計算
  // japanTime = new Date(now.getTime() + japanTimeOffset * 60000)

  return japanTime
}

// 公開期限のチェックを行う関数
const checkPublicationPeriod = (start, end) => {
  // 現在の日本時間を取得
  const currentTime = getJapanTime()

  // 日付文字列をDateオブジェクトに変換
  const startDate = new Date(start)
  const endDate = new Date(end)

  // 日付オブジェクトが有効かどうかをチェック
  const isStartDateValid = !isNaN(startDate.getTime())
  const isEndDateValid = !isNaN(endDate.getTime())

  // フラグの初期値をfalseに設定
  let flag = false

  // 両方有る場合 → 期限内なら表示
  if (isStartDateValid && isEndDateValid) {
    if (currentTime >= startDate && currentTime <= endDate) {
      flag = true
    }
  }
  // 両方無い場合 → 表示
  else if (!isStartDateValid && !isEndDateValid) {
    flag = true
  }
  // startが有りendが無い場合 → startが現在時刻より前の場合表示, そうでない場合非表示
  else if (isStartDateValid && !isEndDateValid) {
    if (currentTime >= startDate) {
      flag = true
    }
  }
  // startが無しendが有りの場合 → 表示、endの時間になれば非表示
  else if (!isStartDateValid && isEndDateValid) {
    if (currentTime <= endDate) {
      flag = true
    }
  }

  return flag
}

// Function to create menu HTML
const createHeaderMenuHTML = (menu, slider) => {
  let html = ''

  menu.forEach((item) => {
    if (checkPublicationPeriod(item.date.start, item.date.end)) {
      html += `
        <div
          class="PartsGlobalNav_navWrapper__l1cXv"
          data-nav-open="false"
          data-nav-nochild="${item.children ? 'false' : 'true'}"
          data-nav-type="header"
          data-nav-onhover="false"
        >
          <p class="js-trigger">
            <a
              class="PartsGlobalNav_navTitle__m_oke"
              href="${item.url}"
            >
              ${item.title}
              <span class="sp-only flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.65 5H11m0 0L6.565 9M11 5 6.565 1"></path></svg></span>
            </a>
          </p>
      `
      if (item.children) {
        html += '<div class="PartsGlobalNav_navBg__FXlNa">'
        if (item.title === 'ラインアップ') {
          // スライダー
          html += createHeaderSliderHTML(slider)
        }
        html += `<ul class="PartsGlobalNav_navList__dQw8j js-nav-list" data-col="${
          item.title === 'ラインアップ' ? 4 : 3
        }">`
        html += createHeaderChildMenuHTML(item.children)
        html += '</ul>'
        html += `
          <div class="PartsGlobalNav_navReadMore__UbeZb">
              <a
                class="UiReadMore_link__SVMfN"
                href="${item.url}"
              >
                <div class="UiReadMore_inner__wrjOL">
                  <p class="UiReadMore_text___UbCv">
                    一覧を見る
                  </p>
                  <div class="UiReadMore_icon__E11BP">
                    <span class="UiReadMore_arrow__UCLUj flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 12 10"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M.65 5H11m0 0L6.565 9M11 5 6.565 1"
                        >
                        </path>
                      </svg>
                    </span>
                  </div>
                </div>
              </a>
            </div>`
        html += '</div>'
      }
      html += `</div>`
    }
  })

  html += `<div class="BaseHeader_menuBottom__llQyH">
            <a
              class="UiOfficialButton_link__Rx7_I"
              data-icon-only="false"
              href="https://cocorostore.jp.sharp/smartdevice/lp?utm_source=dash_header&amp;utm_medium=k-tai_media&amp;utm_campaign=header"
            >
              <span class="UiOfficialButton_text__7RPBS">シャープ公式ストア</span>
              <span class="UiOfficialButton_icon__Ml7ze flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 12 16"
                >
                  <g
                    stroke="currentColor"
                    clip-path="url(#icon_store_svg__a)"
                  >
                    <rect
                      width="11"
                      height="11"
                      x="0.5"
                      y="4.25"
                      rx="1.5"
                    ></rect>
                    <path
                      stroke-linecap="round"
                      d="M7.983 6.25c0-3.314 0-5-1.984-5s-1.983 1.686-1.983 5"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="icon_store_svg__a">
                      <path
                        fill="currentColor"
                        d="M0 0h12v16H0z"
                      ></path>
                    </clipPath>
                  </defs>
                </svg></span></a>
            <div class="BaseHeader_sns__nZX7A">
              <p class="BaseHeader_snsTitle__DFGEk">OFFICIAL SNS</p>
              <ul class="BaseHeader_snsList__r7bEE">
                <li>
                  <a href="https://www.facebook.com/sharpmobile.jp">
                    <span
                      class="UiSnsIcon_snsLink__zvhsV"
                      data-sns-icon="facebook"
                    >
                      <span class="UiSnsIcon_snsImage__xmV2U flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 28 22"
                        >
                          <path
                            fill="#000"
                            d="M9 11.984V8.067h3.25V7.79c.004-1.024-.021-2.05.02-3.073.05-1.226.397-2.35 1.228-3.269.704-.779 1.59-1.196 2.594-1.354 1.128-.177 2.26-.061 3.39.02.17.012.34.032.518.049V3.66h-.223c-.732.01-1.464-.001-2.195.038-.89.05-1.381.548-1.416 1.466-.035.937-.013 1.876-.015 2.815 0 .02.011.038.025.08h3.701l-.486 3.915h-3.239V22h-3.9V11.982H9z"
                          ></path>
                        </svg>
                      </span>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/aquosmobile_official/">
                    <span
                      class="UiSnsIcon_snsLink__zvhsV"
                      data-sns-icon="instagram"
                    >
                      <span class="UiSnsIcon_snsImage__xmV2U flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 28 22"
                        >
                          <mask
                            id="icon_instagram_svg__aaa"
                            width="21"
                            height="22"
                            x="4"
                            y="0"
                            maskUnits="userSpaceOnUse"
                            style="mask-type: luminance;"
                          >
                            <path
                              fill="#fff"
                              d="M10.151.573c-1.117.052-1.88.231-2.547.493-.69.269-1.275.63-1.857 1.214a5.15 5.15 0 0 0-1.208 1.862c-.258.668-.434 1.432-.483 2.55-.049 1.12-.06 1.477-.055 4.328.006 2.851.018 3.209.072 4.33.053 1.116.231 1.879.493 2.546.27.69.63 1.275 1.214 1.857a5.15 5.15 0 0 0 1.862 1.208c.668.258 1.432.434 2.55.483 1.12.05 1.477.06 4.328.055 2.852-.006 3.209-.018 4.329-.071 1.117-.054 1.88-.233 2.547-.493.69-.27 1.275-.63 1.857-1.215a5.15 5.15 0 0 0 1.208-1.862c.258-.668.434-1.432.483-2.549.049-1.12.06-1.478.055-4.33-.006-2.85-.019-3.208-.072-4.327s-.232-1.88-.493-2.548a5.15 5.15 0 0 0-1.214-1.857 5.1 5.1 0 0 0-1.862-1.208c-.668-.258-1.432-.434-2.55-.483-1.12-.05-1.477-.06-4.328-.055-2.851.006-3.209.018-4.329.072m.123 18.981c-1.024-.044-1.58-.215-1.95-.357a3.3 3.3 0 0 1-1.21-.783 3.3 3.3 0 0 1-.787-1.206c-.144-.37-.317-.926-.365-1.95-.052-1.106-.064-1.438-.069-4.242-.005-2.803.005-3.135.053-4.242.044-1.023.215-1.58.357-1.95.19-.491.417-.84.784-1.21a3.25 3.25 0 0 1 1.206-.787c.37-.144.925-.316 1.948-.365 1.108-.052 1.44-.063 4.242-.069 2.804-.005 3.136.005 4.244.053 1.023.045 1.579.214 1.949.357.49.19.84.417 1.209.784.368.367.596.715.788 1.206.144.37.316.925.365 1.948.052 1.107.064 1.44.07 4.242.005 2.804-.006 3.136-.054 4.243-.045 1.024-.214 1.58-.357 1.95-.19.491-.417.841-.784 1.21a3.3 3.3 0 0 1-1.206.787c-.37.144-.925.317-1.948.365-1.107.052-1.439.064-4.243.07-2.803.005-3.134-.006-4.242-.054m8.56-14.167a1.26 1.26 0 1 0 2.52-.005 1.26 1.26 0 0 0-2.52.005M9.109 11.01a5.391 5.391 0 1 0 10.782-.02 5.391 5.391 0 0 0-10.782.02m1.89-.003a3.5 3.5 0 1 1 7-.013 3.5 3.5 0 0 1-7 .013"
                            ></path>
                          </mask>
                          <g mask="url(#icon_instagram_svg__aaa)">
                            <mask
                              id="icon_instagram_svg__bbb"
                              width="23"
                              height="24"
                              x="3"
                              y="-1"
                              maskUnits="userSpaceOnUse"
                              style="mask-type: luminance;"
                            >
                              <path
                                fill="#fff"
                                d="M25.832-.322H3.152v22.68h22.68z"
                              ></path>
                            </mask>
                            <g mask="url(#icon_instagram_svg__bbb)">
                              <mask
                                id="icon_instagram_svg__ccc"
                                width="23"
                                height="24"
                                x="3"
                                y="-1"
                                maskUnits="userSpaceOnUse"
                                style="mask-type: luminance;"
                              >
                                <path
                                  fill="#fff"
                                  d="M25.937-.427H3.047v22.89h22.89z"
                                ></path>
                              </mask>
                              <g mask="url(#icon_instagram_svg__ccc)">
                                <mask
                                  id="icon_instagram_svg__ddd"
                                  width="23"
                                  height="24"
                                  x="3"
                                  y="-1"
                                  maskUnits="userSpaceOnUse"
                                  style="mask-type: luminance;"
                                >
                                  <path
                                    fill="#fff"
                                    d="M25.937-.427H3.047v22.89h22.89z"
                                  ></path>
                                </mask>
                                <g mask="url(#icon_instagram_svg__ddd)">
                                  <path
                                    fill="#000"
                                    d="M3.039-.431h22.902v22.902H3.039z"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@AQUOSPHONESharp/featured">
                    <span
                      class="UiSnsIcon_snsLink__zvhsV"
                      data-sns-icon="youtube"
                    >
                      <span class="UiSnsIcon_snsImage__xmV2U flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 28 22"
                        >
                        <path
                          fill="#000"
                          d="M27.417 4.123a3.54 3.54 0 0 0-2.476-2.526C22.756 1 14 1 14 1s-8.756 0-10.94.597A3.54 3.54 0 0 0 .586 4.123C0 6.35 0 11 0 11s0 4.65.585 6.877a3.54 3.54 0 0 0 2.476 2.526C5.244 21 14 21 14 21s8.756 0 10.94-.597a3.54 3.54 0 0 0 2.475-2.526C28 15.65 28 11 28 11s0-4.65-.585-6.877z"
                        ></path>
                        <path
                          fill="#fff"
                          d="M11.2 15.285 18.475 11l-7.277-4.285z"
                        ></path>
                        </svg>
                      </span>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <small class="BaseHeader_copyRight___OirN">© 2024 SHARP CORPORATION</small>
          </div>`
  return html
}
const createHeaderChildMenuHTML = (child) => {
  let html = ''
  child.forEach((item) => {
    if (checkPublicationPeriod(item.date.start, item.date.end)) {
      html += `<li class="PartsGlobalNav_navItem__HNMsp">
        ${
          item.image
            ? `
          <div class="PartsGlobalNav_icon__8Ra7P">
            <img
              alt=""
              loading="lazy"
              width="122"
              height="124"
              decoding="async"
              data-nimg="1"
              src="${item.image.url}"
              style="color: transparent;"
            >
          </div>
        `
            : ''
        }
        <a
          class="UiLinkText_link__G4hJ9"
          data-link-position="header"
          target=""
          rel=""
          href="${item.url}"
        >
          <span class="UiLinkText_icon__H5Gde flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 12 10"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M.65 5H11m0 0L6.565 9M11 5 6.565 1"
              >
              </path>
            </svg>
          </span>
          <span>
            ${
              item.text
                ? `<p class="UiLinkText_text__Ea6KU">${item.text}</p>`
                : ''
            }
            <p class="UiLinkText_title__yn6Yj">${item.title}</p>
          </span>
        </a>
        </li>
    `
    }
  })
  return html
}
const createHeaderSliderHTML = (slider) => {
  if (slider.length === 0) {
    return null
  }

  let width = window.innerWidth
  let isSp = width <= 768 ? true : false
  const cardsPerView = isSp ? 2 : 5
  let html = `
    <section
      class="productSlider"
      data-place="header"
    >
      <div class="container">
        <div
          id="swiperHeader"
          class="swiper"
          data-swiper=${slider.length > cardsPerView ? 'true' : 'false'}
        >
          <div
            class="swiper-wrapper"
          >`
  slider.forEach((item) => {
    if (checkPublicationPeriod(item.acf['date-end'], item.acf['date-start'])) {
      if (slider.length > cardsPerView) {
        html += `
        <div class="swiper-slide">
          <div
            class="swiper-slide"
          >
            <a
              class="link"
              href="${item.acf['product-url']}"
            >
              <div class="image">
                <img
                  alt=""
                  loading="lazy"
                  width="630"
                  height="630"
                  decoding="async"
                  data-nimg="1"
                  src="${item.acf['product-image'].url}"
                  style="color: transparent;"
                >
              </div>
              <div class="logo">
                <img
                  alt=""
                  loading="lazy"
                  width="432"
                  height="64"
                  decoding="async"
                  data-nimg="1"
                  src="${item.acf['product-logo'].url}"
                  style="color: transparent;"
                >
              </div>
            </a>
          </div>
        </div>
      `
      } else {
        html += `
        <div
          class="swiper-slide"
        >
          <a
            class="link"
            href="${item.acf['product-url']}"
          >
            <div class="image">
              <img
                alt=""
                loading="lazy"
                width="630"
                height="630"
                decoding="async"
                data-nimg="1"
                src="${item.acf['product-image'].url}"
                style="color: transparent;"
              >
            </div>
            <div class="logo">
              <img
                alt=""
                loading="lazy"
                width="432"
                height="64"
                decoding="async"
                data-nimg="1"
                src="${item.acf['product-logo'].url}"
                style="color: transparent;"
              >
            </div>
          </a>
        </div>
      `
      }
    }
  })
  html += `</div>`
  if (slider.length > cardsPerView) {
    html += `<div class="swiper-scrollbar swiper-scrollbar-horizontal">
    <div class="swiper-scrollbar-drag"></div>
    </div>`
    html += `<div class="navigation">
      <div class="prev">
        <span class="icon flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 8"><path stroke="currentColor" stroke-linecap="round" d="M9 7.222 5 1 1 7.222"></path></svg></span>
      </div>
      <div class="next">
        <span class="icon flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 8"><path stroke="currentColor" stroke-linecap="round" d="M9 7.222 5 1 1 7.222"></path></svg></span>
      </div>
    </div>
    `
  }
  html += `</div>
      </div>
    </section>
  `

  return html
}
const createFooterMenuHTML = (menu) => {
  let html = ''

  menu.forEach((item) => {
    if (checkPublicationPeriod(item.date.start, item.date.end)) {
      html += `
        <div
          class="PartsGlobalNav_navWrapper__l1cXv"
          data-nav-open="false"
          data-nav-nochild="${item.children ? 'false' : 'true'}"
          data-nav-type="footer"
          data-nav-onhover="false"
        >
          <p class="js-trigger">
            <a
              class="PartsGlobalNav_navTitle__m_oke"
              href="${item.url}"
            >
              ${item.title}
              <span class="sp-only flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.65 5H11m0 0L6.565 9M11 5 6.565 1"></path></svg></span>
            </a>
          </p>
      `
      html += '<div class="PartsGlobalNav_navBg__FXlNa">'
      html += `<ul class="PartsGlobalNav_navList__dQw8j js-nav-list" data-col="${
        item.title === 'ラインアップ' ? 4 : 3
      }">`
      html += `
          <li class="PartsGlobalNav_navItem__HNMsp">
            <a
              class="UiLinkText_link__G4hJ9"
              data-link-position="footer"
              target=""
              rel=""
              href="${item.url}"
            >
              <span class="UiLinkText_icon__H5Gde flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 12 10"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M.65 5H11m0 0L6.565 9M11 5 6.565 1"
                  ></path>
                </svg>
              </span>
              <span>
                <p class="UiLinkText_text__Ea6KU"></p>
                <p class="UiLinkText_title__yn6Yj">${item.title}一覧</p>
              </span>
            </a>
          </li>
        `
      if (item.children) {
        html += createFooterChildMenuHTML(item.children)
      }
      html += '</ul>'
      html += '</div>'
    }
    html += `</div>`
  })
  return html
}
const createFooterChildMenuHTML = (child) => {
  let html = ''
  child.forEach((item) => {
    if (checkPublicationPeriod(item.date.start, item.date.end)) {
      html += `<li class="PartsGlobalNav_navItem__HNMsp">
        <a
          class="UiLinkText_link__G4hJ9"
          data-link-position="footer"
          target=""
          rel=""
          href="${item.url}"
        >
          <span class="UiLinkText_icon__H5Gde flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 12 10"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M.65 5H11m0 0L6.565 9M11 5 6.565 1"
              >
              </path>
            </svg>
          </span>
          <span>
            <p class="UiLinkText_text__Ea6KU"></p>
            <p class="UiLinkText_title__yn6Yj">${item.title}</p>
          </span>
        </a>
        </li>
    `
    }
  })
  return html
}

document.addEventListener('DOMContentLoaded', async () => {
  let width = window.innerWidth
  const globalMenuUrl =
    'https://gp-dl.4sh.jp/wpcpxy/wp-json/wp/v2/pages/813?acf_format=standard'
  const productSliderUrl =
    'https://gp-dl.4sh.jp/wpcpxy/wp-json/wp/v2/product?per_page=100&acf_format=standard'
  
  let data, headers, productSliderData
  const maxRetries = 3
  let attempts = 0

  while (attempts < maxRetries) {
    try {
      ({ data, headers } = await getData(globalMenuUrl))
      productSliderData = await getData(productSliderUrl)
      
      console.log(data);
      
      break // 成功した場合はループを抜ける
    } catch (error) {
      attempts++
      console.error(`Attempt ${attempts} failed:`, error)
      if (attempts === maxRetries) {
        console.error('Max retries reached. Exiting.')
        // 必要に応じてユーザーにエラーメッセージを表示
        return // エラーが続く場合は、ここで処理を終了
      }
    }
  }
  
/*
  
  const {data, headers} = await getData(globalMenuUrl)
  const productSliderData = await getData(productSliderUrl)
*/
  const productData = () => {
    if (productSliderData.data) {
      return productSliderData.data.filter(
        (product) =>
          product.acf['product-show-global'] === true &&
          product.devices[0].name === 'スマートフォン' &&
          checkPublicationPeriod(
            product.acf['date-start'],
            product.acf['date-end']
          )
      )
    }
  }
  const productFilterData = productData()

  function updateDisplay() {
    let width = window.innerWidth
    if (width <= 1024) {
      const sns = document.querySelector('.BaseHeader_sns__nZX7A')
      const storeText = document.querySelector('.BaseHeader_storeText__lnIbx')
      const hamburger = document.querySelector('.UiHamburgerButton_menu__A26cd')
      const officialButton = document.querySelector(
        '.UiOfficialButton_link__Rx7_I'
      )
      const officialButtonIcon = officialButton.querySelector(
        '.UiOfficialButton_icon__Ml7ze'
      )
      const officialButtonText = officialButton.querySelector(
        '.UiOfficialButton_text__7RPBS'
      )
      sns.style.display = 'none'
      storeText.style.display = 'block'
      hamburger.style.display = 'flex'
      officialButton.dataset.iconOnly = 'true'
      officialButtonText.style.display = 'none'
      officialButtonIcon.style.display = 'flex'
      const footerBG = document.querySelector('.BaseFooter_bg__7fcPj img')
      const src = footerBG.getAttribute('src')
      const newSrc = src.replace('-pc.', '-sp.')
      footerBG.setAttribute('src', newSrc)
    } else {
      const sns = document.querySelector('.BaseHeader_sns__nZX7A')
      const storeText = document.querySelector('.BaseHeader_storeText__lnIbx')
      const hamburger = document.querySelector('.UiHamburgerButton_menu__A26cd')
      const officialButton = document.querySelector(
        '.UiOfficialButton_link__Rx7_I'
      )
      const officialButtonText = officialButton.querySelector(
        '.UiOfficialButton_text__7RPBS'
      )
      sns.style.display = 'block'
      storeText.style.display = 'none'
      hamburger.style.display = 'none'
      officialButtonText.style.display = 'block'
      officialButton.dataset.iconOnly = 'false'
      const footerBG = document.querySelector('.BaseFooter_bg__7fcPj img')
      const src = footerBG.getAttribute('src')
      const newSrc = src.replace('-sp.', '-pc.')
      footerBG.setAttribute('src', newSrc)
    }
  }

  
  let header = document.querySelector('.BaseHeader_header__apMeG')
  let outputTarget = header.querySelector('.BaseHeader_menuInner__0nKQ_')
  function headerExists() {
    let header = document.querySelector('.BaseHeader_header__apMeG')
    let outputTarget = header.querySelector('.BaseHeader_menuInner__0nKQ_')
    return outputTarget !== null
  }
  function waitForHeaderAndExecute() {
    if (headerExists()) {
      // headerが存在する場合に実行したい関数を呼び出す
      headerExecuteFunction()
    } else {
      // headerが存在しない場合、一定時間後に再度チェックする
      setTimeout(waitForHeaderAndExecute, 1000) // 1000ミリ秒 (1秒) 後に再度チェック
    }
  }
  function headerExecuteFunction() {
    function afterHeaderMenu() {
      console.log('afterHeaderMenu')
      header.style.height = 'auto'
      const headerHeight = header.clientHeight
      const style = document.createElement('style')
      style.innerHTML = `
      .BaseHeader_header__apMeG::before {
          top: ${headerHeight}px;
      }`
      document.head.appendChild(style)

      const buttonGroup = header.querySelector('.BaseHeader_buttonGroup__60Q_h')
      const menu = header.querySelector('.BaseHeader_menu__E57Bo')
      if (buttonGroup) {
        buttonGroup.style.opacity = '1'
      }
      if (menu) {
        menu.style.opacity = '1'
      }

      const headerSVGs = header.querySelectorAll('svg')
      headerSVGs.forEach((svg) => {
        svg.style.height = 'auto'
      })

      // hoverした時の処理
      if (width >= 1024) {
        const hoverItem = header.querySelectorAll(
          '.PartsGlobalNav_navWrapper__l1cXv'
        )
        hoverItem.forEach((item) => {
          if (item.dataset.navNochild === 'false') {
            item.addEventListener('mouseenter', function () {
              item.dataset.navOnhover = 'true'
            })
            item.addEventListener('mouseleave', function () {
              item.dataset.navOnhover = 'false'
            })
          }
        })
      }

      // ハンバーガーメニューの開閉
      const hamburgerButton = document.querySelector(
        '.UiHamburgerButton_menu__A26cd'
      )
      const BaseHeaderHeader = document.querySelector(
        '.BaseHeader_header__apMeG'
      )
      hamburgerButton.addEventListener('click', function () {
        // hamburgerButtonのdata属性 data-openがtrueの時はfalseに、falseの時はtrueにする
        const isOpen = hamburgerButton.dataset.open === 'true'
        hamburgerButton.dataset.open = !isOpen
        if (isOpen) {
          BaseHeaderHeader.classList.remove('is-open');
        } else {
          BaseHeaderHeader.classList.add('is-open');
        }
        const body = document.querySelector('body')
        if (!body.dataset.overflow) {
          body.dataset.overflow = 'hidden'
        } else {
          delete body.dataset.overflow
        }
      })

      // PartsGlobalNav_navWrapper__l1cXvのアコーディオン
      // スマホの時はクリックで開閉
      if (width <= 1024) {
        const navWrapper = document.querySelectorAll(
          '.PartsGlobalNav_navWrapper__l1cXv'
        )
        const headerHeight =
          document.querySelector('.BaseHeader_header__apMeG').clientHeight || 0
        const localNav = document.querySelector(
          '.PartsProductNav_productNav__Q_RjK'
        )
        let localNavHeight = 0
        if (localNav) {
          localNavHeight = localNav.clientHeight
        }
        // スクロールを調整するための関数
        const adjustScroll = (amount) => {
          window.scrollBy({
            top: amount,
            behavior: 'smooth',
          })
        }

        // クリックおよびタッチイベントを処理する関数
        const handleMenuClick = (e) => {
          if (e.target && e.target.classList.contains('js-trigger')) {
            e.preventDefault()
            e.stopPropagation()
            const isOpen = e.currentTarget.dataset.navOpen === 'true'
            e.currentTarget.dataset.navOpen = !isOpen
            setTimeout(() => {
              const updatedRect = e.target.getBoundingClientRect()
              const updatedTop =
                updatedRect.top - headerHeight - localNavHeight / 2
              if (updatedTop < 0) {
                adjustScroll(updatedTop)
              }
            }, 500)
          }
        }

        navWrapper.forEach((item) => {
          if (item.dataset.navNochild === 'false') {
            item.addEventListener('click', handleMenuClick, {
              passive: false,
            })
            item.addEventListener('touchstart', handleMenuClick, {
              passive: false,
            })
          }
        })
      }
      const swiperHeader = header.querySelector('#swiperHeader')
      function swiperHeaderExists() {
        return swiperHeader !== null
      }
      function waitForSwiperHeaderAndExecute() {
        if (swiperHeaderExists()) {
          // headerが存在する場合に実行したい関数を呼び出す
          (0,_swiper_js__WEBPACK_IMPORTED_MODULE_0__.initializeSwiper)()
          window.addEventListener('resize', _swiper_js__WEBPACK_IMPORTED_MODULE_0__.initializeSwiper)
        } else {
          // headerが存在しない場合、一定時間後に再度チェックする
          setTimeout(waitForSwiperHeaderAndExecute, 1000) // 1000ミリ秒 (1秒) 後に再度チェック
        }
      }
      waitForSwiperHeaderAndExecute()

      const allowedDomains = ['k-tai.sharp.co.jp', 'jp.sharp']
      const allLinks = document.querySelectorAll('a')
      allLinks.forEach((anchor) => {
        const href = anchor.getAttribute('href')
        if (href) {
          const url = new URL(href, window.location.origin)
          const domain = url.hostname

          if (
            !allowedDomains.some((allowedDomain) =>
              domain.endsWith(allowedDomain)
            )
          ) {
            anchor.setAttribute('target', '_blank')
            anchor.setAttribute('rel', 'noopener noreferrer')
          }
        }
      })
      updateDisplay()
    }

    header = document.querySelector('.BaseHeader_header__apMeG')
    outputTarget = header.querySelector('.BaseHeader_menuInner__0nKQ_')
        
    const menuHTML = createHeaderMenuHTML(data.acf.menu, productFilterData)
    outputTarget.innerHTML = menuHTML
    function menuExists() {
      return outputTarget.childElementCount > 0
    }
    function waitForMenuAndExecute() {
      if (menuExists()) {
        // headerが存在する場合に実行したい関数を呼び出す
        afterHeaderMenu()
      } else {
        // headerが存在しない場合、一定時間後に再度チェックする
        setTimeout(waitForMenuAndExecute, 1000) // 1000ミリ秒 (1秒) 後に再度チェック
      }
    }
    waitForMenuAndExecute()
  }
  waitForHeaderAndExecute()
  

  function footerExists() {
    return document.querySelector('.BaseFooter_footer__HMaCx') !== null
  }
  function waitForFooterAndExecute() {
    if (footerExists()) {
      footerExecuteFunction()
    } else {
      setTimeout(waitForFooterAndExecute, 1000) // 1000ミリ秒 (1秒) 後に再度チェック
    }
  }
  function footerExecuteFunction() {
    const footer = document.querySelector('.BaseFooter_footer__HMaCx')
    if (footer) {
      let outputTarget = footer.querySelector('.BaseFooter_nav__JLm7O')
      function checkFooterParts () {
        let outputTarget = footer.querySelector('.BaseFooter_nav__JLm7O')
          if (data && data.acf.menu) {
            let menuHTML = createFooterMenuHTML(data.acf.menu)
            outputTarget.innerHTML = menuHTML
          }
      }
      if (outputTarget) {
        if (data && data.acf.menu) {
          let menuHTML = createFooterMenuHTML(data.acf.menu)
          outputTarget.innerHTML = menuHTML
        }
      } else {
        setTimeout(checkFooterParts, 1000) // 1000ミリ秒 (1秒) 後に再度チェック
      }

      const shareFacebook = document.querySelector('.share-facebook')
      const shareX = document.querySelector('.share-x')
      const pageURL = window.location.href
      const pageTitle = document.title ?? 'スマートフォンAQUOS'
      if (shareFacebook) {
        shareFacebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          pageURL
        )}&quote=${encodeURIComponent(
          pageTitle
        )}&hashtag=%23スマートフォンAQUOS `
      }
      if (shareX) {
        shareX.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(pageURL)}&text=${encodeURIComponent(pageTitle)}&hashtags=スマートフォンAQUOS `
      }

      const footerSVGs = footer.querySelectorAll('svg')
      footerSVGs.forEach((svg) => {
        svg.style.height = 'auto'
      })

      // 現在の年を取得
      const currentYear = new Date().getFullYear()
      // IDが "copyright-year" の要素を取得
      const copyrightYearElement = document.getElementById('copyright-year')
      // 取得した要素に現在の年を設定
      if (copyrightYearElement) {
        copyrightYearElement.textContent = currentYear
      }
      // PartsGlobalNav_navWrapper__l1cXvのアコーディオン
      // スマホの時はクリックで開閉
      if (width <= 1024) {
        const navWrapper_f = document.querySelectorAll(
          '.BaseFooter_nav__JLm7O .PartsGlobalNav_navWrapper__l1cXv'
        )
        const headerHeight_f =
          document.querySelector('.BaseHeader_header__apMeG').clientHeight || 0
        const localNav_f = document.querySelector(
          '.PartsProductNav_productNav__Q_RjK'
        )
        let localNavHeight_f = 0
        if (localNav_f) {
          localNavHeight_f = localNav_f.clientHeight
        }
        // スクロールを調整するための関数
        const adjustScroll = (amount) => {
          window.scrollBy({
            top: amount,
            behavior: 'smooth',
          })
        }

        // クリックおよびタッチイベントを処理する関数
        const handleMenuClick = (e) => {
          if (e.target && e.target.classList.contains('js-trigger')) {
            e.preventDefault()
            e.stopPropagation()
            const isOpen_f = e.currentTarget.dataset.navOpen === 'true'
            e.currentTarget.dataset.navOpen = !isOpen_f
            setTimeout(() => {
              const updatedRect_f = e.target.getBoundingClientRect()
              const updatedTop_f =
                updatedRect_f.top - headerHeight_f - localNavHeight_f / 2
              if (updatedTop_f < 0) {
                adjustScroll(updatedTop_f)
              }
            }, 500)
          }
        }

        navWrapper_f.forEach((item) => {
          if (item.dataset.navNochild === 'false') {
            item.addEventListener('click', handleMenuClick, {
              passive: false,
            })
            item.addEventListener('touchstart', handleMenuClick, {
              passive: false,
            })
          }
        })
      }
    }
  }
  waitForFooterAndExecute()

  // ウィンドウサイズが変更されたときのためにイベントリスナーを追加
  window.addEventListener('resize', updateDisplay)
})
